export const a11yProps = (index: number) => ({
  id: `vertical-tab-${index}`,
  'aria-controls': `vertical-tabpanel-${index}`,
});

export const opponentStyles = {
  alignItems: 'center',
  justifyContent: { md: 'flex-start', sm: 'center', xs: 'center' },
  width: '100%',
  backgroundColor: 'myGrey.grey4e',
  borderRadius: '8px',
  height: { lg: '57vh', md: '34vh', sm: '30vh' },
  '@media (max-width:500px)': {
    height: '22vh',
  },
  maxHeight: '609px',
};

export const smallModalPadding = {
  lg: '64px 40px 52px',
  md: '24px',
  sm: '24px',
  xs: '24px',
};

export const smallModalClosePosition = { lg: 12, md: 8, sm: 8, xs: 8 };
